import type { FieldSetProps } from 'butlerapp-integration/src/components/FieldSet/FieldSet';
import { HStack, Text, VStack } from '~/molecules';
import { StyleSheet } from 'react-native-unistyles';
import { RenderHtml } from '~/components/RenderHtml/RenderHtml';
import { HtmlContent } from '~/components/RenderHtml';
import { BookingLayoutContext } from '../hooks/BookingLayoutContext';
import { useId } from 'react';

type AdminFieldSetProps = FieldSetProps & {
    options?: { title?: string };
};

export function AdminFieldSet(props: AdminFieldSetProps) {
    const title = props.title ?? props.options?.title;
    const titleId = useId();
    const Content = props.isInline ? HStack : VStack;

    return (
        <VStack role="group" aria-labelledby={title ? titleId : undefined} style={styles.root}>
            {!title ? null : (
                <Text nativeID={titleId} role="heading" style={styles.title}>
                    <RenderHtml documentFlow>{String(title)}</RenderHtml>
                </Text>
            )}
            {!props.description ? null : <HtmlContent>{String(props.description)}</HtmlContent>}
            <BookingLayoutContext.Provider value={!!props.isInline}>
                <Content style={[styles.content, props.isInline && styles.inline]}>{props.children}</Content>
            </BookingLayoutContext.Provider>
        </VStack>
    );
}

const styles = StyleSheet.create((theme) => ({
    root: {
        backgroundColor: theme.colors.surface,
        borderRadius: theme.shapes.corner.small,
        gap: theme.spacings['3'],
        minWidth: 0,
        padding: theme.spacings['3'],
        width: '100%',
    },
    content: {
        gap: theme.spacings['3'],
        minWidth: 0,
        width: '100%',
    },
    inline: {
        alignItems: 'stretch',
        flexWrap: 'wrap',
    },
    title: {
        ...theme.typescale.titleMedium,
        color: theme.colors.onSurface,
        fontWeight: '600',
    },
}));
